import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog/dialog";
import { MachineSelector } from "./machine-selector";
import { ROUTES } from "@/routes";

export function MachineSelectorDialog() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleOpenChange = useCallback(
    (open: boolean) =>
      void (!open && setTimeout(() => navigate(ROUTES.HOME), 500)),
    [navigate]
  );

  const handleNavigation = useCallback(() => {
    navigate(ROUTES.HOME);
  }, [navigate]);

  return (
    <Dialog defaultOpen onOpenChange={handleOpenChange}>
      <DialogContent className="w-[90%] max-w-[1500px]  max-h-full [@media(max-height:756px)]:h-full [@media(max-height:756px)]:min-h-full">
        <DialogHeader>
          <DialogTitle>{t("machineDialog.title")}</DialogTitle>
        </DialogHeader>
        <DialogBody className="bg-header-foreground flex flex-col flex-grow h-full overflow-auto">
          <MachineSelector
            onCancel={handleNavigation}
            onSuccess={handleNavigation}
            onClear={handleNavigation}
          />
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
}
